// RecordCard.jsx
import React from 'react';
import { Card } from 'antd';
import { format } from 'date-fns';

// The RecordCard component
const InfoCard = ({ data, title }) => {
    let startDate = null;
    let endDate = null;

    // Safely handle splitting phenomenonTime
    if (data?.phenomenonTime) {
        const splitDates = data.phenomenonTime.split("/");
        startDate = splitDates[0] || null;
        endDate = splitDates[1] || null;
    }

    // Format the dates only if they are valid
    const formattedStartDate = startDate ? format(new Date(startDate), "dd MMMM yyyy") : "N/A";
    const formattedEndDate = endDate ? format(new Date(endDate), "dd MMMM yyyy") : "N/A";

    return (
        <Card title={title} variant="borderless">
            {data?.name && <p><strong>Name: </strong>{data?.name}</p>}
            {data?.parameters?.name && <p><strong>Name: </strong>{data?.parameters?.name}</p>}
            {data?.description && <p><strong>Description: </strong>{data?.description}</p>}
            {data?.parameters?.GTIN && <p><strong>GTIN: </strong>{data?.parameters?.GTIN}</p>}
            {data?.parameters?.idParcel && <p><strong>Parcel ID: </strong>{data?.parameters?.idParcel}</p>}
            {data?.parameters?.lotNumber && <p><strong>Lot Number: </strong>{data?.parameters?.lotNumber}</p>}
            {data?.parameters?.foiId && <p><strong>foiId: </strong>{data?.parameters?.foiId}</p>}
            {data?.parameters?.id && <p><strong>ID: </strong>{data?.parameters?.id}</p>}
            {data?.parameters?.inferenceId && <p><strong>Inference ID: </strong>{data?.parameters?.inferenceId}</p>}
            {data?.parameters?.markerTypeId && <p><strong>Marker Type ID: </strong>{data?.parameters?.markerTypeId}</p>}
            {data?.parameters?.status && <p><strong>Status: </strong>{data?.parameters?.status}</p>}
            {data?.phenomenonTime && 
                <>
                    <p><strong>Start Date: </strong>{formattedStartDate}</p>
                    <p><strong>End Date: </strong>{formattedEndDate}</p>
                </>
            }
            {data?.result?.complianceMarker && <p><strong>Compliance Marker: </strong>{data?.result?.complianceMarker}</p>}
        </Card>
    );
};

export default InfoCard;
